import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Lock, KeyRound, Clock, AlertTriangle, CheckCircle2 } from 'lucide-react';

const SECURITY_CARDS = [
  {
    testid: 'security-lockout', icon: Lock, title: 'Account Lockout', subtitle: 'Brute force protection',
    rows: [['Max failed attempts', '5'], ['Lockout duration', '15 min']],
    badge: 'Active',
  },
  {
    testid: 'security-password-policy', icon: KeyRound, title: 'Password Policy', subtitle: 'Minimum requirements',
    rows: [['Minimum length', '8 characters'], ['Strength meter', 'Enabled']],
    badge: 'Enforced',
  },
  {
    testid: 'security-sessions', icon: Clock, title: 'Session Management', subtitle: 'JWT cookie-based auth',
    rows: [['Access token', '8 hours'], ['Refresh token', '7 days'], ['Secure cookies', 'Yes']],
    badge: 'Secure',
  },
];

export default function SecurityTab() {
  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {SECURITY_CARDS.map(card => {
          const Icon = card.icon;
          return (
            <Card key={card.testid} className="border-[#DED8EB] shadow-sm" data-testid={card.testid}>
              <CardContent className="pt-5 space-y-3">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded-xl bg-[#F0EDF6] flex items-center justify-center">
                    <Icon className="h-5 w-5 text-[#6B3FA0]" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-[#2D1B4E]">{card.title}</p>
                    <p className="text-xs text-[#8E85A0]">{card.subtitle}</p>
                  </div>
                </div>
                <div className="text-sm text-[#5A4D6E] space-y-1 bg-[#F7F4EF] rounded-lg p-3">
                  {card.rows.map(([k, v]) => (
                    <p key={k} className="flex justify-between"><span>{k}</span><span className="font-semibold text-[#2D1B4E]">{v}</span></p>
                  ))}
                </div>
                <Badge className="bg-green-100 text-green-700 gap-1"><CheckCircle2 className="h-3 w-3" />{card.badge}</Badge>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card className="border-[#DED8EB] shadow-sm" data-testid="security-audit">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-semibold text-[#2D1B4E] flex items-center gap-2">
            <AlertTriangle className="h-4 w-4 text-[#FFB74D]" /> Security Notes
          </CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="text-sm text-[#5A4D6E] space-y-2">
            {[
              'All passwords are bcrypt-hashed with unique salts',
              'Authentication uses secure httpOnly cookies (SameSite=None)',
              'Failed login attempts trigger automatic 15-minute lockout after 5 tries',
              'Only administrators can manage user roles and reset passwords',
            ].map(note => (
              <li key={note} className="flex items-start gap-2">
                <CheckCircle2 className="h-4 w-4 text-green-500 shrink-0 mt-0.5" />{note}
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
